<template>
  <div style="background-color: #F1F4FB;">
    <div class="px-4 mx-auto py-10 sm:max-w-xl md:max-w-full lg:max-w-screen-xl sm:px-6 md:px-8 lg:px-10">
      <div class="pb-5">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }" class="myColor">EMHUB</el-breadcrumb-item>
          <el-breadcrumb-item>关于EMHUB</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <img :src="baseOSSUrl + '/linchuang1.png'" class="w-full h-full" alt="">
      <div class="mb-20 text-sm font-medium" style="color: #666666;letter-spacing: 1px;">
        <p class="mt-5">
          EMHUB（European Medical Hub“欧洲医疗服务中心“）作为综合型的医疗线上平台，整合了世界前沿临床技术、科学研究及医学教育，旨在成为中西方医疗合作与交流的平台。</p>
        <p class="my-5">
          “医疗沟通无国界、学术交流一线通”-- EMHUB的使命是打造并搭建中欧医疗合作的桥梁，促进中欧医生的临床、科研和学术交流，为中国的医疗服务提供线上及线下的支持，促进多方合作共赢。
        </p>
        <p>
          EMHUB提供多元化的线上及线下服务内容，包含：<br/>
          — 全球知名专家课程、知识点录播、讲座；<br/>
          — 网络座谈会议，如线上手术直播、案例讨论、新设备实践与应用等：<br/>
          — MDT（多学科诊疗）支持，针对复杂病例、患者线上就诊、跨国会诊提供解决方案;<br/>
          — 提供现场支持，包括癌症、神经系统疾病、心血管疾病、肾功能衰竭、骨科等疾病的诊断及手术现场指导，短期或长期现场工作支持。
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import {
baseOSSUrl
} from '@/utils/oss';
export default {
  name: "aboutEmhub",
  data() {
    return {
      baseOSSUrl
    }
  }
}
</script>

<style scoped>
.myColor /deep/ .el-breadcrumb__inner {
  color: #123B7F ;
}
.myColor >>> .el-breadcrumb__inner:hover {
  color: #123B7F;
}
</style>